import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RecurrentShiftService } from '../../services/recurrentShift.service';
import { IClientJob } from 'src/modules/company-dashboard/interfaces/client-job.interface';
import * as moment from 'moment-timezone';
import { getShiftAlsoAcceptsSkill, skillShortLabel as pswPcaShortLabel } from 'src/modules/shared/utils/helpers/psw-pca-pair.helper';

@Component({
  selector: 'app-shift-tag',
  templateUrl: './shift-tag.component.html',
  styleUrls: ['./shift-tag.component.scss'],
})
export class ShiftTagComponent implements OnInit {

  @Input() jobItem: IClientJob;
  @Input() onlyRecurrentJobs: boolean;
  @Input() state? : string;
  @Input() previousShiftView? : boolean = false;
  // Opt-in reskin hook: the client requests page passes 'staffy-requests'; every other caller renders as before
  @Input() cssClass: string = '';
  @Output() onEditShift? = new EventEmitter();
  @Output() onDeleteShift? = new EventEmitter();
  shiftInterval: string;
  shiftIntervalDays: string;
  shiftInformation: string;
  showTrainingStyle: boolean;
  shiftDuration: number;
  jobStatus: string;
  
  constructor(
    private recurrentShiftService: RecurrentShiftService
  ) { }

  getAlsoAcceptsSkill(jobItem: IClientJob): string | null {
    return getShiftAlsoAcceptsSkill(jobItem as any);
  }

  skillShortLabel(skill: string): string {
    return pswPcaShortLabel(skill);
  }

  ngOnInit() {
    
    if(!this.jobItem) {
      return;
    }

    this.shiftDuration = moment.duration(this.jobItem.shiftEndTime - this.jobItem.shiftStartTime, 'seconds').asHours();

    this.evaluateJobStatus()

    this.showTrainingShiftStyling();

    //If the shift is not recurrent then return by marking it as training or not. Do not calculate interval messade
    if(!this.jobItem || !this.jobItem.recurrentShiftTemplateId) {
      return
    } 

    const recurrentShiftTemplate = this.jobItem.recurrentShiftTemplateId;

    this.shiftInterval = this.recurrentShiftService.formatShiftInterval(recurrentShiftTemplate);
    this.shiftIntervalDays = this.recurrentShiftService.convertDaysToShortFormat(recurrentShiftTemplate.days);
    this.shiftInformation = this.recurrentShiftService.shiftInformation(this.jobItem);
  }


  showTrainingShiftStyling() {
    //Check if non recurring or recurring shift is a training shift
    //If true, apply training shift CSS (Show orange outline), otherwise apply regular CSS
    this.showTrainingStyle =  this.jobItem.isTrainingShift;
  }

  handleEditShift(event: Event) {
    this.onEditShift.emit(event);
  }

  handleDeleteShift() {
    this.onDeleteShift.emit();
  }

  evaluateJobStatus(){
    if (!this.previousShiftView) return;

    const { isFilled, isABroadcastRequest, staffersAndShifts } = this.jobItem;

    this.jobStatus = isFilled ? 'Filled' : 'Unfilled';

    if (this.jobStatus !== 'Filled') return;

    // Check if it's a broadcast request and vacancies match staff count
    const isCompletedBroadcast =
      isABroadcastRequest &&
      isABroadcastRequest.vacancies === staffersAndShifts.length;

    if (!isCompletedBroadcast && isABroadcastRequest.isTrue) return;

    // If all staffers are in "complete" state, mark as Completed
    const allComplete = staffersAndShifts.every(staffer => staffer.state === 'complete');
    this.jobStatus = allComplete ? 'Completed' : 'Filled';
  }

}
